import { useEffect, useState } from "react";

import { TextField } from "@mui/material";

interface TextEditProps {
  value: string;
  onChange: (_val: string) => void;
  inputRef?: any;
  error?: string;
}

const TextEdit = ({ value, onChange, inputRef, error }: TextEditProps) => {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (localValue !== value) {
        onChange(localValue ?? "");
      }
    }, 500);

    return () => clearTimeout(handler);
  }, [localValue, onChange, value]);

  return (
    <TextField
      error={!!error}
      helperText={error}
      inputRef={inputRef}
      onChange={(e) => setLocalValue(e.target.value)}
      size="small"
      value={localValue ?? ""}
      variant="standard"
      fullWidth
    />
  );
};

export default TextEdit;
